import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BillingApiService } from '../services/billing-api.service';
import { ChargebeeStoreApiService } from '../services/chargebee-store-api.service';
import { StoreApiService } from '../services/store-api.service';
import {
  StorePaymentAPI,
  StorePurchaseApi,
  StoreSubscriptionAPI,
  StoreTaxExemptionAPI,
  StoreValidateAddressAPI,
} from '../store-api';

export const storePurchaseAPIInjector = new InjectionToken<StorePurchaseApi>(
  'StorePurchaseApi',
);
export const storePaymentAPIInjector = new InjectionToken<StorePaymentAPI>(
  'StorePaymentAPI',
);
export const storeTaxExemptionAPIInjector =
  new InjectionToken<StoreTaxExemptionAPI>('StoreTaxExemptionAPI');
export const storeValidateAddressAPIInjector =
  new InjectionToken<StoreValidateAddressAPI>('StoreValidateAddressAPI');
export const storeSubscriptionAPIInjector =
  new InjectionToken<StoreSubscriptionAPI>('StoreSubscriptionAPI');

export function provideStoreApiService() {
  return [
    {
      provide: storePurchaseAPIInjector,
      useClass:
        environment.CHARGEBEE === 'V2'
          ? ChargebeeStoreApiService
          : StoreApiService,
    },
    {
      provide: storePaymentAPIInjector,
      useClass:
        environment.CHARGEBEE === 'V2'
          ? ChargebeeStoreApiService
          : StoreApiService,
    },
    { provide: storeTaxExemptionAPIInjector, useClass: StoreApiService },
    { provide: storeValidateAddressAPIInjector, useClass: StoreApiService },
    {
      provide: storeSubscriptionAPIInjector,
      useClass:
        environment.CHARGEBEE === 'V2'
          ? ChargebeeStoreApiService
          : BillingApiService,
    },
  ];
}
